import React from 'react';
import PropTypes from 'prop-types';
/* Components */
import {Formik, Form, Field, ErrorMessage} from 'formik';
import Modal from '../../common/modal/modal';
import RadioButton from '../../common/form-elements/radio-button/radio-button';
import Avatar from '../../common/avatar/avatar';
import FormErrorMessage from '../../common/form-elements/form-error-message/form-error-message';
import ImageCropper from '../../common/image-cropper';
/* Helpers */
import {imageUpload, schemaValidate} from '../../../helpers/validation-helpers';
/* Styles */
import './settings-modal.scss';

class DashboardImageSettingsModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedImageOptionId: this.props.selectedImageOptionId,
      uploadedImage: null,
    };
  }

  handleSave = (values) => {
    this.props.onSave({selectedImageOptionId: values.selectedImageOptionId, image: values.image});
    this.props.onClose();
  };

  closeAndDiscard = () => {
    this.props.onClose();
  };

  handleImageUpload = (image) => {
    this.setState({
      uploadedImage: image,
    });
  };

  handleImageUploadCancel = () => {
    this.setState({
      uploadedImage: null,
    });
  };

  handleImageCrop = (props) => (image) => {
    props.setFieldValue('image', image);
    this.setState({
      uploadedImage: null,
    });
  };

  render() {
    return (
      <Modal.Default isOpen={this.props.isOpen}>
        <Formik
          initialValues={{
            selectedImageOptionId: this.state.selectedImageOptionId,
            image: this.props.image,
          }}
          onSubmit={this.handleSave}
        >
          {(props) => {
            return (
              <Form>
                <div className="glu-modal__header glu-flex glu-flex-align-center">
                  <div className="glu-modal__title glu-flex-grow">Select dashboard image</div>
                  <div className="glu-flex-shrink">
                    <button
                      aria-label="close"
                      type="button"
                      className="glu-btn-link g-icon g-icon-close"
                      onClick={this.closeAndDiscard}
                    />
                  </div>
                </div>
                <div className="glu-modal__body">
                  <div className="glu-content__section">
                    {this.props.imageUploadOptions &&
                      this.props.imageUploadOptions.map((option) => (
                        <div className="glu-form-row" key={option.imageOption}>
                          <Field
                            as={RadioButton}
                            name="selectedImageOptionId"
                            value={option.imageOption}
                            onChange={props.handleChange}
                            isChecked={option.imageOption === props.values.selectedImageOptionId}
                          >
                            <div className="glu-radio__image-setting">{option.label}</div>
                          </Field>
                        </div>
                      ))}
                    {props.values.selectedImageOptionId === 'DEFAULT' && (
                      <div className="glu-form-row">
                        <div className="glu-flex-row glu-flex-grow glu-flex-align-center glu-col-pad--lg-big">
                          <div className="glu-flex-shrink">
                            <Avatar imageSrc={this.props.defaultImage} size="lg" />
                          </div>
                          <div className="glu-flex-grow glu-h5 text-secondary">
                            A dashboard image can help you quickly choose a dashboard from the
                            dashboard library.
                          </div>
                        </div>
                      </div>
                    )}
                    {props.values.selectedImageOptionId === 'DISABLED' && (
                      <div className="glu-form-row">
                        <div className="glu-flex-row glu-flex-grow glu-flex-align-center glu-col-pad--lg-big">
                          <div className="glu-flex-shrink">
                            <Avatar size="lg" imageSrc={null} isEmpty />
                          </div>
                          <div className="glu-flex-grow glu-h5 text-secondary">
                            A dashboard image can help you quickly choose a dashboard from the
                            dashboard library.
                          </div>
                        </div>
                      </div>
                    )}
                    {props.values.selectedImageOptionId === 'CUSTOM' && (
                      <div className="glu-form-row">
                        <div className="glu-flex-row glu-flex-grow glu-flex-align-center glu-col-pad--lg-big">
                          <div className="glu-flex-shrink">
                            <Field
                              as={Avatar}
                              name="image"
                              handleImageUpload={this.handleImageUpload}
                              validate={schemaValidate(imageUpload())}
                              size="lg"
                              isEditable
                              imageSrc={props.values.image}
                            />
                            <ErrorMessage name="image" component={FormErrorMessage} />
                          </div>
                          <div className="glu-flex-grow glu-h5 text-secondary">
                            A dashboard image can help you quickly choose a dashboard from the
                            dashboard library.
                          </div>
                        </div>
                      </div>
                    )}
                    <Modal.Default isOpen={!!this.state.uploadedImage}>
                      <ImageCropper
                        imageSource={this.state.uploadedImage}
                        handleCancel={this.handleImageUploadCancel}
                        handleCrop={this.handleImageCrop(props)}
                      />
                    </Modal.Default>
                  </div>
                </div>
                <footer className="glu-modal__footer">
                  <div className="glu-flex-grow glu-flex-row">
                    <div className="glu-flex-grow text-right">
                      <button
                        type="button"
                        onClick={this.closeAndDiscard}
                        className="glu-btn glu-btn--secondary"
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="glu-flex-shrink">
                      <button className="glu-btn glu-btn--primary" type="submit">
                        Save
                      </button>
                    </div>
                  </div>
                </footer>
              </Form>
            );
          }}
        </Formik>
      </Modal.Default>
    );
  }
}

DashboardImageSettingsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedImageOptionId: PropTypes.string.isRequired,
  imageUploadOptions: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  defaultImage: PropTypes.string.isRequired,
  image: PropTypes.string,
};

DashboardImageSettingsModal.defaultProps = {
  image: '',
};

export default DashboardImageSettingsModal;
